import { inject, injectable, injectWithTransform } from "tsyringe";
import { DataWarehouseSender } from "./data-warehouse-sender";
import {
  Browser,
  Geo,
  HttpClient,
  Logger,
  LoggerTransformer,
  OperatingSystem,
  Skin,
  WikiConfig,
} from "@identity/utils";
import { WINDOW } from "@identity/symbols";
import { OptInService } from "../OptInService";
import { dataWarehouseUrls } from "./data-warehouse-urls";

@injectable()
export class LoadTimeEventSender extends DataWarehouseSender {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "DataWarehouseService")
    logger: Logger,
    @inject(HttpClient) httpClient: HttpClient,
    @inject(Skin) skin: Skin,
    @inject(OptInService) optInService: OptInService,
    @inject(WINDOW) window: Window,
    @inject(WikiConfig) wikiConfig: WikiConfig,
    @inject(Geo) geo: Geo,
    @inject(Browser) browser: Browser,
    @inject(OperatingSystem) operatingSystem: OperatingSystem,
  ) {
    super(
      logger,
      httpClient,
      skin,
      optInService,
      window,
      wikiConfig,
      geo,
      browser,
      operatingSystem,
      dataWarehouseUrls.loadtime,
    );
  }

  send(metricName: string): void {
    this.sendEvent(
      {
        event_name: metricName,
        load_time: this.getCurrentTimestamp() - this.getStartTime(),
      },
      this.dataWarehouseUrl,
    );
  }
}
